import { tProvidersProps } from '../LayoutProvider/Layout.types.ts';
import { SyncConversationsContext } from './SyncConversations.context.tsx';
import { useSyncConversations } from './SyncConversations.hook.ts';

export default function SyncConversationsProvider(props: tProvidersProps) {
  const { children } = props;
  const syncConversations = useSyncConversations();

  return (
    <SyncConversationsContext.Provider value={syncConversations}>
      {children}
    </SyncConversationsContext.Provider>
  );
}
